"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperationDuration = void 0;
class OperationDuration {
    static getTryCatchFinallyHook(_ctx) {
        return this;
    }
    static getPriority() {
        return -1000;
    }
    static onTry(ctx) {
        ctx.start = Date.now();
    }
    static onFinally(ctx) {
        if (ctx.start !== undefined)
            ctx.duration = Date.now() - ctx.start;
    }
    static getDuration(ctx) {
        return ctx.duration;
    }
}
exports.OperationDuration = OperationDuration;
//# sourceMappingURL=OperationDuration.js.map